import React from 'react';
import { AppBar, Box, Button, Stack, Toolbar } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';

export interface NavigationHeaderProps {
  backUrl?: string;
  onBackClick?: () => void;
  leftItems?: React.ReactNode;
  rightItems?: React.ReactNode;
  global?: boolean;
}

export const NavigationHeader: React.FC<NavigationHeaderProps> = ({
  backUrl,
  onBackClick,
  leftItems,
  rightItems,
  global = false,
}) => {
  const handleBack = async () => {
    if (onBackClick) {
      await onBackClick();
    }
  };

  return (
    <AppBar
      color='primary'
      position='static'
      className={`lex-navigation-header ${global ? 'lex-navigation-header--global' : ''}`}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 2,
      }}
    >
      <Toolbar
        sx={{
          flexGrow: 1,
          px: 4,
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', flexGrow: 1, alignItems: 'center', gap: 2 }}>
          {backUrl && (
            <Button
              href={backUrl}
              onClick={handleBack}
              size='small'
              className='icon-only'
            >
              <ChevronLeft />
            </Button>
          )}
          {leftItems}
        </Box>
        {rightItems && <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>{rightItems}</Box>}
      </Toolbar>
    </AppBar>
  );
};

export default NavigationHeader;
